import Portfolio1 from "./Portfolio1";
import Portfolio2 from "./Portfolio2";

const portfolios = {
    1: Portfolio1,
    2: Portfolio2
};

export default portfolios;